import request from "@/utils/request.util";
import qs from "qs";

export const getProfileAccountManagement = async () => {
  return request.get("/staffs/show_profile");
};
export const updateProfileAccountManagement = async (payload) => {
  return request.put(`/staffs/update_profile`, payload);
};

// get view list user

export const getViewListUser = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("/staffs/", params);
};

export const deleteUser = async (id, restaurantId) => {
  const params = {
    params: { restaurant_id: restaurantId },
  };
  return request.delete(`/staffs/${id}`, params);
};

// get role user
export const getRoleUser = async () => {
  return request.get("/staffs/new");
};

// create new user
export const createNewUser = async (payload, restaurantId) => {
  const params = {
    params: { restaurant_id: restaurantId },
  };
  return request.post("/staffs", payload, params);
};

// update user
export const editUser = async (id, payload, restaurantId) => {
  const params = {
    params: { restaurant_id: restaurantId },
  };
  return request.put(`/staffs/${id}`, payload, params);
};

// get view user
export const getViewEditUser = async (id, restaurantId) => {
  const params = {
    params: { restaurant_id: restaurantId },
  };
  return request.get(`/staffs/${id}/edit`, params);
};

// resend invitation (Phase 1)
export const resendInvite = async (id, restaurantId) => {
  const params = {
    params: { restaurant_id: restaurantId },
  };
  return request.post(`/staffs/${id}/resend_invite`, null, params);
};

// reset password
export const resetPasswordUser = async (payload) => {
  return request.post("/staffs/forgot_password", payload);
};

// get list city
export const getListCity = async (payload = { restaurantId: "1" }) => {
  const params = {
    restaurant_id: payload.restaurantId,
  };
  const query = `${qs.stringify(params)}`;
  return request.get(`/cities?${query}`);
};

// get list districts
export const getListDistricts = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("/districts", params);
};

// get store detail
export const getStoreDetail = async (payload) => {
  const params = {
    restaurant_id: payload,
  };
  const query = `${qs.stringify(params)}`;
  return request.get(`/restaurants/view_store?${query}`);
};

export const getStoreDetailEmbed = async (payload) => {
  const queryParams = {
    restaurant_id: payload.restaurantId,
  };
  const params = {
    params: { restaurant_id: payload.restaurantId },
  };
  if (payload.token) {
    params.headers = { Authorization: `Bearer ${payload.token}` };
  }
  const query = `${qs.stringify(queryParams)}`;
  return request.get(`/restaurants/view_store?${query}`, params);
};

export const updateStore = async (payload) => {
  return request.put("/restaurants/update_store", payload);
};

export const updateProgress = async (payload) => {
  return request.put("restaurants/update_steps_verify", payload);
};

export const getDocuments = async (payload) => {
  const params = {
    restaurant_id: payload.restaurantId,
  };
  const query = `${qs.stringify(params)}`;
  return request.get(`restaurant_documents?${query}`);
};

export const updateDocuments = async (payload) => {
  return request.post("restaurants/create_documents", payload, {
    headers: { "content-type": "multipart/form-data" },
  });
};

export const reverseGeocode = async (payload) => {
  const params = {
    params: payload,
  };
  return request.get("restaurants/reverse_geocode", params);
};

export const createTemporaryStaff = async (payload) => {
  const params = {
    restaurantId: payload,
  };
  return request.post("staffs/create_temporary_staff", params);
};
